const userFlags = {
    None : 0,
    LeaderNotifications : 1,
    AgencyLeaderNotifications : 2,
    PlanWillCancel : 4,
    ShowFamilyOnAgency: 8,
    PremiumSMS: 16
}

export default userFlags